module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-05.524d5a21.png";